/** @file Image px -> slot-bone affine of a compiled attachment: the frame loadSkeleton places handles with. */
import { meshPixelToLocal } from '@pose2d/core/load/meshPixelToLocal';
import { regionPixelToLocal } from '@pose2d/core/load/regionPixelToLocal';
import type { AtlasJson, AtlasRegion, Pose2DJson } from '@pose2d/format/types';
import type { Affine } from '@pose2d/math/types';

type RigRegion = Extract<Pose2DJson['attachments'][number], { type: 'region' }>;

/** A region's (baked) placement with the rig defaults, as the loader reads it. */
function regionFrame(att: RigRegion, region: AtlasRegion): Affine {
  const { x = 0, y = 0, rotation = 0, scaleX = 1, scaleY = 1, w, h } = att;
  return regionPixelToLocal({ x, y, rotation, scaleX, scaleY, w, h, origW: region.origW, origH: region.origH });
}

/** Regions through their (baked) transform and size, meshes through the pixel -> vertex fit (R-E1-15). */
export function handleFrame(json: Pose2DJson, atlas: AtlasJson, index: number): Affine | null {
  const att = json.attachments[index];
  const region = att === undefined ? undefined : atlas.regions[att.image];
  if (att === undefined || region === undefined) return null;
  if (att.type === 'mesh') return meshPixelToLocal(att.uvs, region.origW, region.origH, att.vertices ?? null);
  return regionFrame(att, region);
}
